import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  const isAdmin = currentUser && currentUser.roles && 
                  currentUser.roles.some(role => role === 'ROLE_ADMIN');
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  if (!isAdmin) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          <h4>Access Denied</h4>
          <p>You don't have permission to access this page. Admin privileges required.</p>
        </div>
      </div>
    );
  }
  
  return children;
};

export default AdminRoute;